
























import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { isFunction } from 'lodash';
import { GridApi } from 'ag-grid-community';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import {
  FormFieldDefMap,
  emitFormChangeEvent,
} from '@/reusable/Form/formUtils';
import moment from 'moment';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
// import { TipoDte } from '@/pantallas/SucursalVirtual/VerFacturacion/fetchTipoDte';
// import { TipoEstado } from '@/pantallas/SucursalVirtual/VerFacturacion/fetchEstados';
@Component({
  components: {
    DatePicker,
    FormFieldsContainer,
  },
})
export default class FiltrosBusqueda extends Vue {
  formFields: FormFieldDefMap = {
    rut: {
      label: 'Buscar...',
      id: 'rut',
      value: '',
    },
  };

  created() {
    var self = this;
    this.$parent.$on('limpiarSearch', () => {
      self.formFields.rut.value = '';
    });
  }

  handleBuscarClick() {
    this.$emit('resultadoBusqueda', this.formFields);
    // this.formFields.rut.value = '';
  }

  @Watch('formFields', { deep: true })
  handleFormChange(fields: FormFieldDefMap) {
    emitFormChangeEvent(this.$emit.bind(this), {
      entity: {} as any,
    });
  }

  clearFilters() {
    this.formFields.rut.value = '';
    this.$emit('clear');
  }
}
